/**
 * Custom Shopify Theme JavaScript
 */

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
  
  // ============================================
  // MOBILE MENU TOGGLE
  // ============================================
  initMobileMenu();
  
  // ============================================
  // PRODUCT IMAGE GALLERY
  // ============================================
  initProductImageGallery();
  
  // ============================================
  // QUANTITY SELECTOR
  // ============================================
  initQuantitySelector();
  
  // ============================================
  // ADD TO CART FUNCTIONALITY
  // ============================================
  initAddToCart();
  
  // ============================================
  // CART UPDATE
  // ============================================
  initCartUpdate();
  
});

/**
 * Mobile Menu Toggle
 * Handles opening and closing of mobile navigation
 */
function initMobileMenu() {
  const toggleBtn = document.querySelector('.mobile-menu-toggle');
  const closeBtn = document.querySelector('.mobile-menu-close');
  const menuOverlay = document.querySelector('.mobile-menu-overlay');
  const body = document.body;
  
  if (!toggleBtn || !menuOverlay) return;
  
  // Open menu
  toggleBtn.addEventListener('click', function() {
    menuOverlay.classList.add('active');
    body.classList.add('mobile-menu-active');
  });
  
  // Close menu with close button
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      menuOverlay.classList.remove('active');
      body.classList.remove('mobile-menu-active');
    });
  }
  
  // Close menu when clicking on a link
  const navLinks = document.querySelectorAll('.mobile-menu-overlay .nav-link');
  navLinks.forEach(link => {
    link.addEventListener('click', function() {
      menuOverlay.classList.remove('active');
      body.classList.remove('mobile-menu-active');
    });
  });
}

/**
 * Product Image Gallery
 * Handles thumbnail clicks to change main image
 */
function initProductImageGallery() {
  const thumbnailWrappers = document.querySelectorAll('.thumbnail-wrapper');
  const mainImage = document.getElementById('mainProductImage');
  
  if (!thumbnailWrappers.length || !mainImage) return;
  
  thumbnailWrappers.forEach(wrapper => {
    wrapper.addEventListener('click', function() {
      // Remove active class from all wrappers
      thumbnailWrappers.forEach(w => w.classList.remove('active'));
      
      // Add active class to clicked wrapper
      this.classList.add('active');
      
      // Update main image
      const thumbnail = this.querySelector('.thumbnail');
      const fullSizeUrl = thumbnail.getAttribute('data-full-size');
      
      // Fade effect
      mainImage.style.opacity = '0.5';
      setTimeout(() => {
        mainImage.src = fullSizeUrl;
        mainImage.style.opacity = '1';
      }, 150);
    });
  });
}

/**
 * Quantity Selector with +/- Buttons
 * Premium increment/decrement functionality
 */
function initQuantitySelector() {
  const quantitySelectors = document.querySelectorAll('.quantity-selector');
  
  if (!quantitySelectors.length) return;
  
  quantitySelectors.forEach(selector => {
    const minusBtn = selector.querySelector('.quantity-btn.minus');
    const plusBtn = selector.querySelector('.quantity-btn.plus');
    const input = selector.querySelector('input[type="number"]');
    
    if (!minusBtn || !plusBtn || !input) return;
    
    // Decrease quantity
    minusBtn.addEventListener('click', function(e) {
      e.preventDefault();
      let currentValue = parseInt(input.value) || 1;
      let minValue = parseInt(input.getAttribute('min')) || 1;
      
      if (currentValue > minValue) {
        input.value = currentValue - 1;
        // Trigger change event for any listeners
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    
    // Increase quantity
    plusBtn.addEventListener('click', function(e) {
      e.preventDefault();
      let currentValue = parseInt(input.value) || 1;
      let maxValue = parseInt(input.getAttribute('max')) || 99;
      
      if (currentValue < maxValue) {
        input.value = currentValue + 1;
        // Trigger change event for any listeners
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    
    // Validate input on manual entry
    input.addEventListener('change', function() {
      let value = parseInt(this.value) || 1;
      let minValue = parseInt(this.getAttribute('min')) || 1;
      let maxValue = parseInt(this.getAttribute('max')) || 99;
      
      if (value < minValue) this.value = minValue;
      if (value > maxValue) this.value = maxValue;
    });
  });
}

/**
 * Add to Cart with AJAX
 * Prevents page reload and shows feedback
 */
function initAddToCart() {
  const productForm = document.querySelector('.product-form');
  
  if (!productForm) return;
  
  productForm.addEventListener('submit', function(e) {
    // Uncomment below to enable AJAX add to cart (requires additional setup)
    // e.preventDefault();
    
    const button = this.querySelector('.btn-add-to-cart');
    const originalText = button.textContent;
    
    // Show loading state
    button.textContent = 'Adding...';
    button.disabled = true;
    
    // If using regular form submission, the page will reload
    // For AJAX implementation, uncomment below:
    
    /*
    const formData = new FormData(this);
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      // Success
      button.textContent = 'Added!';
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
        updateCartCount();
      }, 1500);
    })
    .catch(error => {
      // Error
      console.error('Error:', error);
      button.textContent = 'Error - Try Again';
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    });
    */
  });
}

/**
 * Update Cart Count in Header
 * Fetches current cart and updates display
 */
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      // Update cart count in navigation
      const cartLinks = document.querySelectorAll('.main-nav a[href="/cart"]');
      cartLinks.forEach(link => {
        link.textContent = `Cart (${cart.item_count})`;
      });
    })
    .catch(error => console.error('Error updating cart count:', error));
}

/**
 * Cart Update Functionality
 * Auto-update when quantity changes
 */
function initCartUpdate() {
  const quantityInputs = document.querySelectorAll('.cart-item-quantity input');
  
  if (!quantityInputs.length) return;
  
  quantityInputs.forEach(input => {
    input.addEventListener('change', function() {
      // Auto-submit form when quantity changes
      // You can add debounce here if needed
      const form = this.closest('form');
      if (form) {
        // Show loading indicator
        const updateBtn = form.querySelector('[name="update"]');
        if (updateBtn) {
          updateBtn.textContent = 'Updating...';
        }
        // Submit form
        form.submit();
      }
    });
  });
}

/**
 * Smooth Scroll for Anchor Links
 */
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

/**
 * Buy Now Functionality
 * Adds to cart and redirects to checkout
 */
function buyNow() {
  const productForm = document.querySelector('.product-form');
  if (!productForm) return;
  
  const formData = new FormData(productForm);
  const button = document.querySelector('.btn-buy-now');
  const originalText = button.innerHTML;
  
  // Show loading state
  button.innerHTML = '<span>Processing...</span>';
  button.disabled = true;
  
  // Add to cart via AJAX
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    // Redirect to checkout
    window.location.href = '/checkout';
  })
  .catch(error => {
    console.error('Error:', error);
    button.innerHTML = originalText;
    button.disabled = false;
    alert('Error adding to cart. Please try again.');
  });
}
